import {Inject, Injectable, PLATFORM_ID} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from "@angular/router";
import {NEVER, Observable, of, throwError} from "rxjs";
import {LandingPageSettingsResponse} from "fello-model";
import {catchError, switchMap} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {LandingPagePublicApiService, StateTransferResolver, UrlUtils} from "fello-common";
import {TransferState} from "@angular/platform-browser";
import {DOCUMENT, isPlatformBrowser} from "@angular/common";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class PurlPageSettingsResponseResolver
  extends StateTransferResolver<LandingPageSettingsResponse>
  implements Resolve<LandingPageSettingsResponse>
{
  constructor(
    private landingPagePublicApiService: LandingPagePublicApiService,
    private router: Router,
    transferState: TransferState,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) private _platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    super(transferState, _platformId);
  }
  resolve2(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<LandingPageSettingsResponse> {
    const purlId = route.paramMap.get("purlId")!;
    const landingPageConfigId = route.paramMap.get("landingPageConfigId");
    return this.landingPagePublicApiService.getPurlPagePublicSettings(purlId, landingPageConfigId ?? undefined).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 404) {
          this.router.navigate(["/not-found"], {skipLocationChange: true});
          return NEVER;
        }
        return throwError(err);
      })
    );
  }

  protected transform(
    obs: Observable<LandingPageSettingsResponse>,
    route: ActivatedRouteSnapshot
  ): Observable<LandingPageSettingsResponse> {
    return obs.pipe(
      switchMap(settings => {
        if (settings?.subdomain && route.data.enableSubdomainFixing && isPlatformBrowser(this._platformId)) {
          const currentUrl = this.document.location.href;
          const updatedUrl = UrlUtils.updateSubdomain(currentUrl, settings.subdomain);
          const currentSubdomain = UrlUtils.getSubdomain(currentUrl);
          if (updatedUrl !== currentUrl) {
            // only try fix url if it is part of allowed subdomains
            if (environment.allowedSubdomains.includes(currentSubdomain)) {
              this.document.location.href = updatedUrl;
              return NEVER;
            }
            this.router.navigate(["/not-found"], {skipLocationChange: true});
            return NEVER;
          }
        }
        return of(settings);
      })
    );
  }
}
